/** ACL routes config: all route out of this list are public, listed route will respect permission level 
 * {
 *   path: '/route/path/with/:params', => the route path to check
 *   redirect:  '/route/path/', => an optional route to redirect app if access has been forbidden
 *   permission: ['SUPERADMIN', 'ADMIN', 'MEMBER'], => list of authorized role names
 * }
 */
const AclRoutes = [
    { 
        path: '/analytics',
        redirect: '/', 
        permissions: ['SUPERADMIN', 'ADMIN'], 
    },
    { 
        path: '/profile',
        redirect: '/', 
        permissions: ['SUPERADMIN', 'ADMIN', 'MEMBER'], 
    },
    { 
        path: '/user/:id',
        redirect: '/profile', 
        permissions: ['SUPERADMIN', 'ADMIN'], 
    },
    { 
        path: '/users/data',
        redirect: '/profile', 
        permissions: ['SUPERADMIN', 'ADMIN'], 
    },
    { 
        path: '/users',
        redirect: '/profile', 
        permissions: ['SUPERADMIN', 'ADMIN'], 
    },
    { 
        path: '/questions',
        redirect: '/profile', 
        permissions: ['SUPERADMIN', 'ADMIN'], 
    },
    { 
        path: '/pos/:id/data',
        redirect: '/pos', 
        permissions: ['SUPERADMIN', 'ADMIN', 'MEMBER'], 
    },
    { 
        path: '/pos/:id',
        redirect: '/pos', 
        permissions: ['SUPERADMIN', 'ADMIN', 'MEMBER'], 
    },
    { 
        path: '/pos',
        redirect: '/profile', 
        permissions: ['SUPERADMIN', 'ADMIN', 'MEMBER'], 
    },
    { 
        path: '/pos-list',
        redirect: '/profile', 
        permissions: ['SUPERADMIN', 'ADMIN', 'MEMBER'], 
    },

    // { 
    //     path: '/profile',
    //     redirect: '/', 
    //     permissions: ['SUPERADMIN', 'ADMIN', 'STORE MANAGER', 'CUSTOMER SERVICE'], 
    // },
    // { 
    //     path: '/user/:id',
    //     redirect: '/profile', 
    //     permissions: ['SUPERADMIN', 'ADMIN', 'STORE MANAGER'], 
    // },
    // { 
    //     path: '/users',
    //     redirect: '/profile', 
    //     permissions: ['SUPERADMIN', 'ADMIN', 'STORE MANAGER'], 
    // },
    // { 
    //     path: '/sign_number',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'], 
    // },
    // {
    //     path: '/sign_number/:gid/pdv_number',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // {
    //     path: '/sign_number/:gid/template/:id',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // {
    //     path: '/sign_number/:gid/template',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // {
    //     path: '/sign_number/:gid/pdv_number/:pid/template/:id',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // {
    //     path: '/sign_number/:gid/pdv_number/:pid/template',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // {
    //     path: '/workflow/:id',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // {
    //     path: '/workflow',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN'],
    // },
    // { 
    //     path: '/contacts',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN', 'STORE MANAGER', 'CUSTOMER SERVICE'], 
    // },
    // { 
    //     path: '/conversations',
    //     redirect: '/conversations', 
    //     permissions: ['SUPERADMIN', 'ADMIN', 'STORE MANAGER', 'CUSTOMER SERVICE'], 
    // },
]

export default AclRoutes;